import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function PageWrapper({ children }) {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        // チャットルームページではスクロールをリセットしない
        if (!pathname.startsWith('/messages/')) {
            window.scrollTo(0, 0);
        }
    }, [pathname, search, hash]);

    return children;
}

export default PageWrapper; 